// extracted by mini-css-extract-plugin
export default {"dialog__text":"ConfirmImportDialog_dialog__text__IjvMM","template__table":"ConfirmImportDialog_template__table__AfVe9","template__cell":"ConfirmImportDialog_template__cell__3g9sw"};